import React, { useContext } from "react";
import { AppContext } from "@vahak/core/dist/app-context";
import AppImg from "components/utils/AppImg";
import Styles from "./Benefits.module.scss";

import SalaryIcon from "@vahak/core/dist/icons/Salary.svg";
import PartyIcon from "@vahak/core/dist/icons/Party.svg";
import HealthyWorkLife from "@vahak/core/dist/icons/healthyWorkLife.svg";
import SystemIcon from "@vahak/core/dist/icons/System.svg";
import RetreatsIcon from "@vahak/core/dist/icons/Retreats.svg";
import PantryIcon from "@vahak/core/dist/icons/Pantry.svg";

const Benefits = () => {
    const { isMobile } = useContext(AppContext);
    return (
        <>
            <div className={Styles.heading}>
                <h2>
                    Let’s take a look at what’s in{" "}
                    <span data-hover="store for you" className={isMobile ? "" : "indaiText"}>
                        store for you
                    </span>
                </h2>
                <p>(Aside from the bundles of fun)</p>
            </div>
            <div className={Styles.benefitsRow}>
                <div className={Styles.benefitCol}>
                    <div className={Styles.textBox}>
                        <div className={Styles.iconBox}>
                            <SalaryIcon width="51" height="66" />
                        </div>
                        <h4>Competitive Salary</h4>
                        <p>There is no “right” salary for the right person! Our salaries are mad-competitive.</p>
                    </div>
                </div>
                <div className={Styles.benefitCol}>
                    <div className={Styles.textBox}>
                        <div className={Styles.iconBox}>
                            <PantryIcon width="51" height="66" />
                        </div>
                        <h4>Stacked Pantry</h4>
                        <p>Fancy a snack, or two? Our pantry’s always loaded with tasty tidbits.</p>
                    </div>
                </div>
                <div className={Styles.benefitCol}>
                    <div className={Styles.textBox}>
                        <div className={Styles.iconBox}>
                            <HealthyWorkLife width="51" height="66" />
                        </div>
                        <h4>Healthy work-life Balance</h4>
                        <p>Think flexible work hours and generous leave policies.</p>
                    </div>
                </div>
                <div className={Styles.benefitCol}>
                    <div className={Styles.textBox}>
                        <div className={Styles.iconBox}>
                            <SystemIcon width="51" height="66" />
                        </div>
                        <h4>Tech of your Choice</h4>
                        <p>Mac-book or Windows? Pick any tech that you are comfortable with!</p>
                    </div>
                </div>
                <div className={Styles.benefitCol}>
                    <div className={Styles.textBox}>
                        <div className={Styles.iconBox}>
                            <RetreatsIcon width="51" height="66" />
                        </div>
                        <h4>Team Retreats</h4>
                        <p>We escape work stress with frequent getaways!</p>
                    </div>
                </div>
                <div className={Styles.benefitCol}>
                    <div className={Styles.textBox}>
                        <div className={Styles.iconBox}>
                            <PartyIcon width="51" height="66" />
                        </div>
                        <h4>Partying Hard</h4>
                        <p>Expect food escapades, team retreats and (lots of) booze!”</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Benefits;
